// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './events-polyfill';
import Vue from 'vue';
import store from './store';
import App from './App';

// eslint-disable-next-line
let Promise = require('es6-promise').polyfill();

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
	el: '#app-mfmm',
	store,
	template: '<App/>',
	components: { App },

	// Vuex is too complex for this use case. Let's use this.$root instead...
	data () {
		return {
			activeMoment: '',
		};
	},
	computed: {
		missingMoment: function () {
			return this.activeMoment === 'ocean' ? 'forest' : 'ocean';
		},
	},
	methods: {
		dispatchEvent (name, data = {}) {
			const event = new CustomEvent(`mfmm:${name}`, { detail: data });
			this.$el.dispatchEvent(event);
		},
	},
});



// WEBPACK FOOTER //
// ./src/main.js